export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--0-0!../../../../node_modules/css-loader/index.js!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PayQues.vue?vue&type=style&index=0&id=7f4bb270&prod&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/Payment/components/private-component/PayQues.vue?vue&type=style&index=0&id=7f4bb270&prod&lang=css
// module id = 263
// module chunks = 0